import * as React from "react"
import {useLocation} from "react-router-dom";

import Header from "./common/Header";
import Footer from "./common/Footer";
import Content from "./Content";
import {ROUTES} from "../helpers/constants";
import AppLoader from "./common/AppLoader";

const yellowBgRoutes = [ROUTES.login, ROUTES.restore, ROUTES.unsubscribe];

const Main = () => {

  let location = useLocation();
  const hasSiteChrome = document.pageInfo ? !!document.pageInfo.hasSiteChrome : false;

  return (
    <div className={"page" + (location && (yellowBgRoutes.includes(location.pathname)) ? " page--member" : "")}>
      {!hasSiteChrome && <Header/>}
      <div className={"member-content" + (hasSiteChrome ? " member-content--product-header" : "")}>
        <Content/>
      </div>
      {!hasSiteChrome && <Footer/>}
      <AppLoader/>
    </div>
  )
}

export default Main
